<script lang="ts" setup>
import { ref, toRef, watch } from "#imports";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const icon = ref<any>("");

try {
  const iconsImport = import.meta.glob(`assets/icons/generic/*.svg`, {
    query: "?raw",
    import: "default",
    eager: false,
  });
  icon.value = await iconsImport[`/assets/icons/generic/${props.name}.svg`]();

  watch(toRef(props, "name"), async () => {
    icon.value = await iconsImport[`/assets/icons/generic/${props.name}.svg`]();
  });
} catch {
  console.error(`The ${props.name} icon does not exist`);
}
</script>

<template>
  <span class="block svg-icon" :class="{ 'svg-icon--disabled': disabled }" v-html="icon"></span>
</template>

<style lang="scss" scoped>
.svg-icon {
  &--disabled {
    pointer-events: none;
    color: var(--grey-medium-light);
  }
}
</style>
